// import { useState } from 'react';
// import { Box, Paper, Grid, TextField, Typography, Checkbox, Button, FormControlLabel } from '@mui/material';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import { ReactComponent as Logo } from "../../img/logo.svg"
// import { useNavigate } from 'react-router-dom';
// import { ApiService } from '../../API/AxiosInstance';
// import moment from 'moment';
// import ToastAlert from '../../utils/Toaster';
// import { getYearDiff } from '../../utils/validation';
// import { captureException } from '@sentry/react';
// import { colors } from '../../Theme/tokens';
// import { ReactComponent as DateIcon } from "../../img/dateIcon.svg"

// const Signup = () => {
//   const localUserData = JSON.parse(localStorage.getItem('userData')) || ''
//   const [localData, setLocalData] = useState(localUserData)
//   const [formErrors, setFormErrors] = useState({});
//   const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})
//   const navigate = useNavigate()
//   const [formValues, setFormValues] = useState({
//     mobileNo: '',
//     dateOfBirth: null,
//     isAccredited: false,
//   });


//   const validate = () => {
//     let errors = {};
//     console.log("formValues?.mobileNo  ",typeof formValues?.mobileNo )
//     if (!formValues?.mobileNo) {
//       errors.mobileNo = "Mobile Number is required.";
//     } else if(formValues?.mobileNo?.length < 5 || formValues?.mobileNo?.length > 15) {
//       errors.mobileNo = "Mobile number must be between 5 and 15 digits long.";
//     }
//     if (!formValues?.dateOfBirth) {
//       errors.dateOfBirth = "Date of Birth is required.";
//     } else if(formValues?.dateOfBirth) {
//       const yearsDifference = getYearDiff(moment(), moment(formValues?.dateOfBirth));
//       if (yearsDifference < 21) {
//         errors.dateOfBirth = 'You must be at least 21 years old';
//       }
//     }
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   }
//   const handleSave = async(userId) => {
//     const validation = validate()
//     if(!validation) return 
//     const formattedValues = {mobileNo:formValues?.mobileNo, accredited:formValues?.isAccredited ? 'true' : 'false',  dateOfBirth: moment(formValues?.dateOfBirth).format('YYYY-MM-DD') || ''}
//     console.log("handleSave ")
//     try {
//         const response =  await ApiService().post(`users/${userId}/complete-profile/update`, formattedValues)
        
//         if(response?.status == 200) {
//           console.log("reposnse ",response)
//           setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})
//           setTimeout(()=>{
//             setToastStatus({color:'',status:false, message:""})
//             localStorage.setItem('signup','No')
//             verifyQuestionarComplete(userId)
//           },3000)
//         }
  
//      } catch(error) {
//         setToastStatus({color:'red',status:true,message: error?.response?.data?.message,icon:'close'})
//           setTimeout(()=>{
//             setToastStatus({color:'',status:false, message:""})
//         },3000)
//         captureException(error)
//      }
//   }

//   const verifyQuestionarComplete = async(user_id) => {
//     console.log("user_id ",user_id)
//     try {
//         const response = await  ApiService().get(`users/${user_id}/onboarding/status`)
//         if(response?.data?.status) {
//           if(response?.data?.status?.completedQuestionnaire == false && !localStorage.getItem('questionaire_skipped')) {
//             navigate('/Questionnaire')
//           } else {
//             navigate('/')
//           }
//         }
//     } catch (error) {
//       captureException(error)
//     }
//   }
// console.log("formValueserror ",formErrors)
//   const handleInputChange = (e, field) => {
//     const value = field === 'isAccredited' ? e.target.checked : e.target.value;
//     if (field === "mobileNo") {
//       const numericRegex = /^\d*$/;
//       if (value.length <=15 && numericRegex.test(value)) {
//         setFormValues((prev) => ({
//           ...prev,
//           [field]: value,
//       }));
//       }
//     } else setFormValues(prevValues => ({ ...prevValues, [field]: value }));
//     setFormErrors(prev => ({...prev, [field]: ''}))
//   };

//   const handleDateChange = (date) => {
//     setFormValues(prevValues => ({ ...prevValues, dateOfBirth: date }));
//   };

//   const handleClear = () => {
//     setFormValues({
//       mobileNo: '',
//       dateOfBirth: null,
//       isAccredited: false,
//     });
//     setFormErrors({});
//   };

//   const handleSubmit = () => {
//     handleSave(localData?.sub_id)
//   };

//   const CustomDateIcon = (props) => <DateIcon {...props} />;

//   return (
//     <>
//     <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />  
//     <Box mt={2} sx={{ backgroundColor: colors.background.paper,  m: 0, width: '100%', height: '100vh', display:"flex", justifyContent:"center", alignItems:"center", minWidth:{xs:"unset", xl:"600px"},  padding: { sm: '40px', xs: '20px 5px' }, }}>
//       <Paper sx={{ backgroundColor: 'white', width:"fit-content", padding: { sm: '30px', xs: '30px' }, borderRadius: '16px',maxWidth:{xs:"520px"},boxShadow:`0px 1px 5px 0px ${colors.border.card}` }}>
//         <Box sx={{ maxWidth: '600px', margin: '0 auto' }}>
//           <Grid container spacing={2}>
            
//             {/* Firstname and Lastname */}
//             <Grid item xs={12}>
//             <Box sx={{ height: '60px', padding: '0px 8px 6px 8px', mb:8 }} >
//                                 <Logo key={1} width='127px !important' />
//                                 <Typography sx={{textAlign:"center", my:1, mt:1.5, mb:4, fontSize:"14px"}}>Please complete your user profile to kickstart your investment journey with TradeTogether.</Typography>
//                             </Box>
//             </Grid>
//             {/* Mobile No */}
//             <Grid item xs={12}>
//               <TextField
//               InputProps={{
//                 sx: {
//                   borderRadius: '15px',
//                   color: colors.text.primary,
//                   fontWeight:"500"
//                 },
//                  maxLength: 15
//               }}
//                 fullWidth
//                 label="Mobile No"
//                 value={formValues?.mobileNo}
//                 onChange={(e) => handleInputChange(e, 'mobileNo')}
//               />
//                 {formErrors?.mobileNo && (
//                 <Typography sx={{ color: 'red', fontSize: '13px', mt: 1 }}>
//                   {formErrors?.mobileNo}
//                 </Typography>
//               )}
//             </Grid>

//             {/* Date of Birth */}
//             <Grid item xs={12}>
//               <LocalizationProvider dateAdapter={AdapterMoment}>
//                 <DatePicker
//                  sx={{width:"100%", borderRadius:"15px",
//                   ".MuiOutlinedInput-notchedOutline": {
//                     borderRadius: "15px",
//                   },
//                 }}
//                   label="Date of Birth"
//                   format="Do MMMM, YYYY"
//                   value={formValues?.dateOfBirth}
//                   onChange={handleDateChange}
//                   // components={{
//                   //     OpenPickerIcon: CustomDateIcon,
//                   // }}
//                   slots={{
//   openPickerIcon: DateIcon,
// }}
//                 //   componentsProps={{
//                 //   openPickerIcon: {
//                 //     sx: { width: 24, height: 24, color: 'red' }, // bright color/size to make it obvious if it's rendering at all
//                 //   },
//                 // }}
//                   renderInput={(params) => <TextField {...params} fullWidth />}
//                 />
//               </LocalizationProvider>
//               {formErrors?.dateOfBirth && (
//                 <Typography sx={{ color: 'red', fontSize: '13px', mt: 1 }}>
//                   {formErrors?.dateOfBirth}
//                 </Typography>
//               )}
//             </Grid>

//             {/* Is Accredited */}
//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={formValues?.isAccredited}
//                     onChange={(e) => handleInputChange(e, 'isAccredited')}
//                   />
//                 }
//                 label="Are you an accredited investor?"
//               />
//             </Grid>

//             {/* Buttons: Clear and Submit */}
//             <Grid item xs={12} display="flex" justifyContent="space-between" sx={{width:"100%"}}>
//               <Button variant="outlined" onClick={handleClear} sx={{width:"40%"}}>
//                 Clear
//               </Button>
//               <Button variant="contained" color="primary" onClick={handleSubmit}  sx={{width:"40%"}} >
//                 Submit
//               </Button>
//             </Grid>
//           </Grid>
//         </Box>
//       </Paper>
//     </Box>
//     </>
//   );
// };

// export default Signup;


import { useState } from 'react';
import { Box, Paper, Grid, TextField, Typography, Checkbox, Button, FormControlLabel } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ReactComponent as Logo } from "../../img/logo.svg"
import { useNavigate } from 'react-router-dom';
import { ApiService } from '../../API/AxiosInstance';
import moment from 'moment';
import ToastAlert from '../../utils/Toaster';
import { getYearDiff } from '../../utils/validation';
import { captureException } from '@sentry/react';
import { colors } from '../../Theme/tokens';
import { ReactComponent as DateIcon } from "../../img/dateIcon.svg"

// Must match the key used in Dashboard.jsx — this is the single source of
// truth for "onboarding fully verified complete" across the app.
const ONBOARDING_COMPLETE_KEY = 'onboardingComplete';

const Signup = () => {
  const localUserData = JSON.parse(localStorage.getItem('userData')) || ''
  const [localData, setLocalData] = useState(localUserData)
  const [formErrors, setFormErrors] = useState({});
  const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})
  const navigate = useNavigate()
  const [formValues, setFormValues] = useState({
    mobileNo: '',
    dateOfBirth: null,
    isAccredited: false,
  });


  const validate = () => {
    let errors = {};
    if (!formValues?.mobileNo) {
      errors.mobileNo = "Mobile Number is required.";
    } else if(formValues?.mobileNo?.length < 5 || formValues?.mobileNo?.length > 15) {
      errors.mobileNo = "Mobile number must be between 5 and 15 digits long.";
    }
    if (!formValues?.dateOfBirth) {
      errors.dateOfBirth = "Date of Birth is required.";
    } else if(formValues?.dateOfBirth) {
      const yearsDifference = getYearDiff(moment(), moment(formValues?.dateOfBirth));
      if (yearsDifference < 21) {
        errors.dateOfBirth = 'You must be at least 21 years old';
      }
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  }

  const handleSave = async(userId) => {
    const validation = validate()
    if(!validation) return
    const formattedValues = {mobileNo:formValues?.mobileNo, accredited:formValues?.isAccredited ? 'true' : 'false',  dateOfBirth: moment(formValues?.dateOfBirth).format('YYYY-MM-DD') || ''}
    try {
        const response =  await ApiService().post(`users/${userId}/complete-profile/update`, formattedValues)

        if(response?.status == 200) {
          setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})

          // Update the cached userData immediately with what we just saved,
          // so any component reading it before the next Dashboard mount sees
          // accurate info rather than stale pre-signup data.
          const updatedUserData = { ...localData, dateOfBirth: formattedValues.dateOfBirth, mobileNo: formattedValues.mobileNo, accredited: formattedValues.accredited }
          localStorage.setItem('userData', JSON.stringify(updatedUserData))
          setLocalData(updatedUserData)

          // Previously this always wrote 'No' regardless of outcome, making
          // the key permanently meaningless. Fixed to reflect the actual
          // completed step.
          localStorage.setItem('signup', 'Yes')

          setTimeout(()=>{
            setToastStatus({color:'',status:false, message:""})
            verifyQuestionarComplete(userId)
          },3000)
        }

     } catch(error) {
        setToastStatus({color:'red',status:true,message: error?.response?.data?.message,icon:'close'})
          setTimeout(()=>{
            setToastStatus({color:'',status:false, message:""})
        },3000)
        captureException(error)
     }
  }

  const verifyQuestionarComplete = async(user_id) => {
    try {
        const response = await  ApiService().get(`users/${user_id}/onboarding/status`)
        if(response?.data?.status) {
          if(response?.data?.status?.completedQuestionnaire == false && !localStorage.getItem('questionaire_skipped')) {
            navigate('/Questionnaire')
          } else {
            // dateOfBirth is saved (we just did it above) AND questionnaire
            // is complete/skipped — onboarding is genuinely done. Set the
            // shared flag now so Dashboard doesn't need to re-hit the API
            // on its next mount.
            localStorage.setItem(ONBOARDING_COMPLETE_KEY, 'true')
            navigate('/')
          }
        }
    } catch (error) {
      captureException(error)
    }
  }

  const handleInputChange = (e, field) => {
    const value = field === 'isAccredited' ? e.target.checked : e.target.value;
    if (field === "mobileNo") {
      const numericRegex = /^\d*$/;
      if (value.length <=15 && numericRegex.test(value)) {
        setFormValues((prev) => ({
          ...prev,
          [field]: value,
      }));
      }
    } else setFormValues(prevValues => ({ ...prevValues, [field]: value }));
    setFormErrors(prev => ({...prev, [field]: ''}))
  };

  const handleDateChange = (date) => {
    setFormValues(prevValues => ({ ...prevValues, dateOfBirth: date }));
  };

  const handleClear = () => {
    setFormValues({
      mobileNo: '',
      dateOfBirth: null,
      isAccredited: false,
    });
    setFormErrors({});
  };

  const handleSubmit = () => {
    handleSave(localData?.sub_id)
  };

  const CustomDateIcon = (props) => <DateIcon {...props} />;

  return (
    <>
    <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />
    <Box mt={2} sx={{ backgroundColor: colors.background.paper,  m: 0, width: '100%', height: '100vh', display:"flex", justifyContent:"center", alignItems:"center", minWidth:{xs:"unset", xl:"600px"},  padding: { sm: '40px', xs: '20px 5px' }, }}>
      <Paper sx={{ backgroundColor: 'white', width:"fit-content", padding: { sm: '30px', xs: '30px' }, borderRadius: '16px',maxWidth:{xs:"520px"},boxShadow:`0px 1px 5px 0px ${colors.border.card}` }}>
        <Box sx={{ maxWidth: '600px', margin: '0 auto' }}>
          <Grid container spacing={2}>

            {/* Firstname and Lastname */}
            <Grid item xs={12}>
            <Box sx={{ height: '60px', padding: '0px 8px 6px 8px', mb:8 }} >
                                <Logo key={1} width='127px !important' />
                                <Typography sx={{textAlign:"center", my:1, mt:1.5, mb:4, fontSize:"14px"}}>Please complete your user profile to kickstart your investment journey with TradeTogether.</Typography>
                            </Box>
            </Grid>
            {/* Mobile No */}
            <Grid item xs={12}>
              <TextField
              InputProps={{
                sx: {
                  borderRadius: '15px',
                  color: colors.text.primary,
                  fontWeight:"500"
                },
                 maxLength: 15
              }}
                fullWidth
                label="Mobile No"
                value={formValues?.mobileNo}
                onChange={(e) => handleInputChange(e, 'mobileNo')}
              />
                {formErrors?.mobileNo && (
                <Typography sx={{ color: 'red', fontSize: '13px', mt: 1 }}>
                  {formErrors?.mobileNo}
                </Typography>
              )}
            </Grid>

            {/* Date of Birth */}
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                 sx={{width:"100%", borderRadius:"15px",
                  ".MuiOutlinedInput-notchedOutline": {
                    borderRadius: "15px",
                  },
                }}
                  label="Date of Birth"
                  format="Do MMMM, YYYY"
                  value={formValues?.dateOfBirth}
                  onChange={handleDateChange}
                  slots={{
                    openPickerIcon: DateIcon,
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
              {formErrors?.dateOfBirth && (
                <Typography sx={{ color: 'red', fontSize: '13px', mt: 1 }}>
                  {formErrors?.dateOfBirth}
                </Typography>
              )}
            </Grid>

            {/* Is Accredited */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formValues?.isAccredited}
                    onChange={(e) => handleInputChange(e, 'isAccredited')}
                  />
                }
                label="Are you an accredited investor?"
              />
            </Grid>

            {/* Buttons: Clear and Submit */}
            <Grid item xs={12} display="flex" justifyContent="space-between" sx={{width:"100%"}}>
              <Button variant="outlined" onClick={handleClear} sx={{width:"40%"}}>
                Clear
              </Button>
              <Button variant="contained" color="primary" onClick={handleSubmit}  sx={{width:"40%"}} >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
    </>
  );
};

export default Signup;